import { FC, useState } from 'react';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import ShareholderForm, { useShareholderForm } from '../forms/ShareholderForm';
import { CustomerCompanyShareholderInformationForm } from '@/pages/frm/customer-v2/CustomerPage';

type ShareholderData = CustomerCompanyShareholderInformationForm & {
	index?: number;
};

type ModalData =
	| { type: 'new' }
	| {
			type: 'edit';
			data: ShareholderData;
	  };

export const useShareholderModal = (
	onSubmit: (type: ModalData['type'], data: ShareholderData) => void,
) => {
	const [modalData, setModalData] = useState<ModalData>();

	return {
		data: modalData,
		isOpen: Boolean(modalData),
		open: (data: ModalData) => setModalData(data),
		close: () => setModalData(undefined),
		onSubmit,
	};
};

const ShareholderModal: FC<ReturnType<typeof useShareholderModal>> = (
	props,
) => {
	const shareholderForm = useShareholderForm((values) => {
		props.close();
		props.onSubmit(props.data!.type, {
			...values,
			index: props.data?.type === 'edit' ? props.data.data.index : undefined,
		});
	});

	const { form } = shareholderForm;

	return (
		<FleetModal
			open={props.isOpen}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onCancel={() => props.close()}
			onOk={form.submit}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data?.type === 'edit') {
					form.setFieldsValue(props.data.data);
				}
			}}
		>
			<FleetTitle>Tambah Pemegang Saham</FleetTitle>
			<ShareholderForm {...shareholderForm} />
		</FleetModal>
	);
};

export default ShareholderModal;
